/* eslint-disable @typescript-eslint/ban-ts-ignore */
import React from 'react';
import { connect } from 'react-redux';
import { appendTicket } from '../index';
import { getQueueSelector } from '../../../selectors/queue-selectors';
import { AppLoadingPanel } from '../../../components/app-loading-panel';
import { NoQueueFound } from '../components/no-queue-found';
import { AuthenticationError } from '../components/authentication-error';

import { openBooth } from '../index';

import { BoothClosed } from '../components/booth-closed';
import { Queue } from '../../../types/queue';
import { BoothTicket } from '../../../types/ticket';
import { RootState } from '../../../root-reducer';
import { QueueList } from '../components/queue-list';
import { Dispatch } from 'redux';

export interface QueueListPageProps {
  initComplete: boolean;
  authError: boolean;
  selectedQueue: Queue;
  queues: Array<Queue>;
  currentTicket: BoothTicket | null;
  previousTickets: Array<BoothTicket>;
  boothStatus: 'open' | 'closed' | 'unknown';
  onAppendTicket: (queueId: string, ticketNote: string) => void;
  onBoothOpen: () => void;
}

export function $QueueListPage(props: QueueListPageProps) {
  const {
    initComplete,
    authError,
    currentTicket,
    previousTickets,
    queues,
    boothStatus,
    onBoothOpen,
    selectedQueue,
    onAppendTicket
  } = props;
  if (!initComplete) {
    return <AppLoadingPanel />;
  }
  const queueIsSelected = selectedQueue && selectedQueue.id;
  if (authError) {
    return <AuthenticationError />;
  }
  if (!queueIsSelected) {
    return <NoQueueFound />;
  }
  if (boothStatus === 'closed') {
    return <BoothClosed onBoothOpen={onBoothOpen} />;
  }
  // const chatClass = this.state.chatOpen ? 'chatOpen' : 'chatHide';
  return (
    <>
      <QueueList
        onAppendTicket={onAppendTicket}
        currentTicket={currentTicket}
        previousTickets={previousTickets}
        queues={queues}
      />

      {/*<section className={styles.sidebar}>*/}
      {/*<button className={styles.chatButton} onClick={this.toggleChat}>*/}
      {/*Chat (<b>{props.commentsCount}</b>)*/}
      {/*</button>*/}
      {/*<Paper zDepth={0} className={`${styles.commentsPanel}  ${styles[chatClass]}`}>*/}
      {/*<Comments />*/}
      {/*</Paper>*/}
      {/*</section>*/}
    </>
  );
}

function mapStateToProperties(state: RootState) {
  return {
    initComplete:
      state.app.initialized && !state.app.initialStatusRequestInProgress,
    authError: state.app.authError,
    commentsCount: 0, //state.comments.items.length,
    queues: state.queues.connectedQueues,
    boothStatus: state.queues.boothStatus,
    currentTicket: state.queues.currentTicket,
    previousTickets: state.queues.previousTickets || [],
    selectedQueue: getQueueSelector(state.queues.selectedQueueId || '')(
      state.queues.connectedQueues
    )
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onBoothOpen: () => dispatch(openBooth()),
    onAppendTicket: (queueId: string, ticketNote: string) =>
      dispatch(appendTicket(queueId, ticketNote))
  };
}
// @ts-ignore
export const QueueListPage = connect(
  mapStateToProperties,
  mapDispatchToProps
)($QueueListPage);
